// src/supabase.js - TEMPORARY for testing
import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_ANON_KEY;
export const supabase = createClient(supabaseUrl, supabaseAnonKey);

console.log("Supabase client loaded:", !!supabase); // Should log "true"
console.log("Env URL:", process.env.REACT_APP_SUPABASE_URL ? "LOADED" : "MISSING");
console.log("Env Key:", process.env.REACT_APP_SUPABASE_ANON_KEY ? "LOADED" : "MISSING");
